module.exports = __webpack_public_path__ + "static/media/mdi_phone.5bde9f63.svg";